module.exports = __webpack_public_path__ + "logo-one-to-one.5525a7ae56ced9425b1f.svg";